import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ToastViewport from './components/ToastViewport';
import { ConfirmProvider } from './context/ConfirmContext';
import AparenciaAplicada from './components/AparenciaAplicada';
import RotaProtegida from './components/RotaProtegida';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ListaEmpresas from './pages/empresas/ListaEmpresas';
import PaginaEmpresa from './pages/empresas/PaginaEmpresa';
import MinhaEmpresa from './pages/empresas/MinhaEmpresa';
import ListaImoveis from './pages/imoveis/ListaImoveis';
import PaginaImovel from './pages/imoveis/PaginaImovel';
import FeedsXml from './pages/FeedsXml';
import Taxonomia from './pages/Taxonomia';
import Configuracoes from './pages/Configuracoes';
import ContasWhatsLight from './pages/ContasWhatsLight';
import EscutaGrupos from './pages/EscutaGrupos';
import AppsStatus from './pages/AppsStatus';
import ListaClientes from './pages/clientes/ListaClientes';
import PaginaCliente from './pages/clientes/PaginaCliente';
import ListaLeads from './pages/leads/ListaLeads';
import PaginaLead from './pages/leads/PaginaLead';
import ListaPedidos from './pages/pedidos/ListaPedidos';
import PaginaPedido from './pages/pedidos/PaginaPedido';
import ListaUsuarios from './pages/usuarios/ListaUsuarios';
import PaginaUsuario from './pages/usuarios/PaginaUsuario';
import EsqueciSenha from './pages/EsqueciSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import Perfil from './pages/Perfil';
import TrocarSenha from './pages/TrocarSenha';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <ToastViewport />
        <AparenciaAplicada />
        <ConfirmProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route element={<RotaProtegida />}>
              <Route element={<Layout />}>
                <Route path="/trocar-senha" element={<TrocarSenha />} />
                <Route path="/perfil" element={<Perfil />} />
                <Route path="/" element={<Dashboard />} />
                <Route path="/imoveis" element={<ListaImoveis />} />
                <Route path="/imoveis/novo" element={<PaginaImovel />} />
                <Route path="/imoveis/:publicId" element={<PaginaImovel />} />
                <Route path="/empresas" element={<ListaEmpresas />} />
                <Route path="/empresas/nova" element={<PaginaEmpresa />} />
                <Route path="/empresas/:publicId" element={<PaginaEmpresa />} />
                <Route path="/minha-empresa" element={<MinhaEmpresa />} />
                <Route path="/taxonomia" element={<Taxonomia />} />
                <Route path="/feeds-xml" element={<FeedsXml />} />
                <Route path="/configuracoes" element={<Configuracoes />} />
                <Route path="/contas-whatslight" element={<ContasWhatsLight />} />
                <Route path="/escuta-grupos" element={<EscutaGrupos />} />
                <Route path="/apps-status" element={<AppsStatus />} />
                <Route path="/clientes" element={<ListaClientes />} />
                <Route path="/clientes/novo" element={<PaginaCliente />} />
                <Route path="/clientes/:publicId" element={<PaginaCliente />} />
                <Route path="/leads" element={<ListaLeads />} />
                <Route path="/leads/:publicId" element={<PaginaLead />} />
                <Route path="/pedidos" element={<ListaPedidos />} />
                <Route path="/pedidos/novo" element={<PaginaPedido />} />
                <Route path="/pedidos/:publicId" element={<PaginaPedido />} />
                <Route path="/usuarios" element={<ListaUsuarios />} />
                <Route path="/usuarios/novo" element={<PaginaUsuario />} />
                <Route path="/usuarios/:publicId" element={<PaginaUsuario />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
        </ConfirmProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
